export function PositionSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/position.svg'"></ng-include>`
    }
}